import { createContext, useContext } from "react";
import type { CheckoutProviderState } from "./types";

export const initialState: CheckoutProviderState = {
  additionalInterests: [],
  isAdditionalInterestsEnabled: false,
  setAdditionalInterests: () => {},
  hasLienholderError: false,
  showModal: false,
  setShowModal: () => {},
  anythingLoading: false,
  documentsLoading: false,
  binderDocumentLoading: false,
  forceAgentSignResponsibility: false,
  isD2C: false,
  getQuoteDocuments: async () => undefined,
  getBinderDocument: async () => undefined,
  onError: () => {},
  onPaymentSuccess: () => {},
  setPaymentLoading: () => {},
  paymentLoading: false,
  policyLocator: "",
  selectedPaymentPlanKey: "annual",
  setLender: () => {},
  setLoanNumber: () => {},
  isMortgageBillFormValid: false,
  setMortgageBillFormValid: () => {},
};

export const CheckoutContext =
  createContext<CheckoutProviderState>(initialState);

export const useCheckout = () => useContext(CheckoutContext);
